<script setup>
import { useI18n } from 'vue-i18n';
defineProps({ action: { type: Object, required: true } });
const { t } = useI18n();
</script>

<template>
  <div
    class="flex min-w-0 flex-col gap-2 break-words rounded-lg border border-n-weak p-3 text-sm"
  >
    <strong>{{ action.quote.store }} — {{ action.quote.order_name }}</strong>
    <span>{{ t('ORDER_ACTIONS.' + action.kind.toUpperCase()) }}</span>
    <p>{{ action.details.reason }}</p>
    <strong v-if="action.quote.amount">
      {{ t('ORDER_ACTIONS.AMOUNT') }}: {{ action.quote.amount }}
      {{ action.quote.currency }}
    </strong>
    <span v-if="action.quote.paid"
      >{{ t('ORDER_ACTIONS.PAID') }}: {{ action.quote.paid }}
      {{ action.quote.currency }}</span
    >
    <span v-if="action.quote.remaining"
      >{{ t('ORDER_ACTIONS.REMAINING') }}: {{ action.quote.remaining }}
      {{ action.quote.currency }}</span
    >
    <span v-if="action.quote.new_total"
      >{{ t('ORDER_ACTIONS.TOTAL') }}: {{ action.quote.new_total.amount }}
      {{ action.quote.new_total.currencyCode }}</span
    >
    <span v-if="action.quote.outstanding"
      >{{ t('ORDER_ACTIONS.OUTSTANDING') }}:
      {{ action.quote.outstanding.amount }}
      {{ action.quote.outstanding.currencyCode }}</span
    >
    <ul v-if="action.quote.changes?.length" class="list-disc pl-4">
      <li v-for="(change, index) in action.quote.changes" :key="index">
        {{ change }}
      </li>
    </ul>
    <p v-if="action.kind === 'edit'">{{ t('ORDER_ACTIONS.EDIT_NOTE') }}</p>
    <span
      >{{ t('ORDER_ACTIONS.NOTIFY') }}:
      {{
        t(action.details.notify ? 'ORDER_ACTIONS.YES' : 'ORDER_ACTIONS.NO')
      }}</span
    >
    <span v-if="['edit', 'cancel'].includes(action.kind)"
      >{{ t('ORDER_ACTIONS.RESTOCK') }}:
      {{
        t(action.details.restock ? 'ORDER_ACTIONS.YES' : 'ORDER_ACTIONS.NO')
      }}</span
    >
  </div>
</template>
